import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { ClickActionEvent } from '../../util/analytics'

import quotesList from "./Data"

import OneQuote from './OneQuote'
 


const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 0, pb: 4, textAlign: 'center' };


export default function FavQuotes() {
  
  


  const [selectedItem, setSelectedItem] = React.useState(0)

  const PreviousQuote = (t)  =>{
    ClickActionEvent("FavQuotesBy "+quotesList[selectedItem].name, 'favourate quotes section', 'favourate previous quote clicked')
    if(selectedItem===0)
      setSelectedItem(quotesList.length-1)
    else
      setSelectedItem(selectedItem-1)
    
  }

  const NextQuote = (event)  =>{
    ClickActionEvent("FavQuotesBy "+quotesList[selectedItem].name, 'favourate quotes section', 'favourate next quote clicked')
    if(selectedItem===quotesList.length-1)
      setSelectedItem(0)
    else
      setSelectedItem(selectedItem+1)
  }

  return (
    <React.Fragment>
 
      <div style={{backgroundColor:"#A4E5E0"}}>

        <Box sx={{ ...sxHeroContent, backgroundColor: '#A4E5E0' }}>
          <Container maxWidth="lx">
            <Typography component="h1" variant="h3" align="center" sx={{ color: '#0c6170' }} gutterBottom>
              My Favourite Quotes 💡
            </Typography>
            <Typography variant="h6" align="center" sx={{ color: '#0c6170' }} paragraph>
              These are some Quotes which I find inspiring...
            </Typography>
          </Container>

        </Box>
        <Container align="center" sx={sxCardGrid} maxWidth="lx">
              <OneQuote item={quotesList[selectedItem]}/>
              <Button style={{backgroundColor:"#0c6170", margin:"10px", color:"#dbf5f0"}} size="small" color="primary" onClick={()=>PreviousQuote()}>
                Previous
              </Button>
              <Button size="small" color="primary" style={{backgroundColor:"#0c6170", margin:"10px", color:"#dbf5f0"}} onClick={()=>NextQuote()}>
                Next
              </Button>
        </Container>
      </div>
 
    </React.Fragment>
  );
}
